import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import CityPicker from './CityPicker';

// 常用时区列表
const TIMEZONES = [
  { offset: '+08:00', name: '中国标准时间 (UTC+8)' },
  { offset: '+09:00', name: '日本标准时间 (UTC+9)' },
  { offset: '+07:00', name: '东南亚西部 (UTC+7)' },
  { offset: '+06:00', name: '中亚 (UTC+6)' },
  { offset: '+05:30', name: '印度 (UTC+5:30)' },
  { offset: '+04:00', name: '迪拜 (UTC+4)' },
  { offset: '+03:00', name: '莫斯科 (UTC+3)' },
  { offset: '+02:00', name: '东欧 (UTC+2)' },
  { offset: '+01:00', name: '中欧 (UTC+1)' },
  { offset: '+00:00', name: 'UTC / 伦敦' },
  { offset: '-05:00', name: '美东 (UTC-5)' },
  { offset: '-08:00', name: '美西 (UTC-8)' },
];

export default class SevenstarForm extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.formData = { ...this.attrs.formData };
    this.timezones = TIMEZONES;
    this.showAdvanced = false;
  }

  view() {
    const { loading, onSubmit } = this.attrs;

    return (
      <form className="TaroSevenstarForm Form" onsubmit={(e) => this.handleSubmit(e)}>
        <div className="Form-group">
          <label>
            <i className="fas fa-clock" />{' '}
            查询时间
          </label>
          <input
            type="datetime-local"
            className="FormControl"
            value={this.formData.drawDatetime}
            oninput={(e) => (this.formData.drawDatetime = e.target.value)}
            step="60"
            required
          />
          <p className="helpText">
            精确到分钟。默认填入当前时间（东八区）。
          </p>
        </div>

        <div className="Form-group">
          <label>
            <i className="fas fa-globe" />{' '}
            时区
          </label>
          <select
            className="FormControl"
            value={this.formData.timezone}
            onchange={(e) => (this.formData.timezone = e.target.value)}
          >
            {this.timezones.map((tz) => (
              <option value={tz.offset}>{tz.name}</option>
            ))}
          </select>
        </div>

        <div className="Form-group">
          <label>
            <i className="fas fa-map-marker-alt" />{' '}
            查询城市
          </label>
          <CityPicker
            country={this.formData.cityCountry}
            province={this.formData.cityProvince}
            city={this.formData.cityCityName}
            onChange={(country, province, cityName, tz, cityId) => {
              this.formData.cityCountry = country;
              this.formData.cityProvince = province;
              this.formData.cityCityName = cityName;
              this.formData.cityId = cityId || '';
            }}
          />
          <p className="helpText">
            默认武汉。{this.formData.cityId && this.formData.cityId !== 'CN-HB-WH' && (
              <span>已选：{this.formData.cityCityName}（{this.formData.cityId}）</span>
            )}
          </p>
        </div>

        <div className="Form-group TaroSevenstarForm-actions">
          <Button
            type="submit"
            className="Button Button--primary"
            loading={loading}
            icon="fas fa-star"
          >
            查询七星
          </Button>
        </div>
      </form>
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    const { onSubmit } = this.attrs;
    if (onSubmit) {
      onSubmit({
        draw_datetime: this.formData.drawDatetime.replace('T', ' '),
        timezone: this.formData.timezone,
        city_id: this.formData.cityId || 'CN-HB-WH',
      });
    }
  }
}
